import { createUseStyles } from 'react-jss';

import colors from "../../../utils/colors";





var styles = {
  browsingSelect: function browsingSelect(_ref) {var isMultiProductPortfolio = _ref.isMultiProductPortfolio;return {
      margin: isMultiProductPortfolio ? '1.5rem 0 0' : '1.5rem 0',
      paddingBottom: '1.5rem',
      borderBottom: "0.1rem solid ".concat(colors.neutral[300]),
      width: '100%',
      // vertical centering select icon
      '& > div:last-child::after': {
        top: '50%',
        transform: 'translateY(-50%)'
      },
      '& select': {
        backgroundColor: colors.blue[100],
        whiteSpace: 'normal',
        fontSize: '1.4rem',
        lineHeight: '2.2rem',
        paddingRight: '3rem',
        color: colors.neutral[700]
      },
      '& label': {
        fontSize: '1.4rem',
        lineHeight: '1.8rem',
        fontStyle: 'italic',
        fontWeight: 300,
        marginBottom: '1rem'
      }
    };},
  singleBrowsingBlock: {
    margin: '1.5rem 0',
    padding: '1rem',
    fontSize: '1.4rem',
    lineHeight: '2rem',
    borderRadius: '0.4rem',
    backgroundColor: colors.blue[100],
    color: colors.neutral[700]
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map